export default __webpack_public_path__ + "static/media/WSLogo.95fa1f36.png";